// Header js
document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('header');
  let lastScrollTop = window.scrollY;
  let ticking = false;

  const menuToggle = document.getElementById('menuToggle');
  const hamburgerIcon = document.getElementById('hamburgerIcon');
  const closeIcon = document.getElementById('closeIcon');
  const mobileMenu = document.getElementById('mobileMenu');
  const overlay = document.getElementById('overlay');
  const internalCloseBtn = document.getElementById('internalCloseBtn');
  const menuItems = document.querySelectorAll('.nav-item-desktop .menu-item-has-children');
  const mobileNav = document.querySelector('.mobile-nav-item');

  if (mobileNav) {
    const parentItems = mobileNav.querySelectorAll('.menu-item-has-children > a');

    parentItems.forEach((parentLink) => {
      parentLink.addEventListener('click', function (e) {
        e.preventDefault();
        const currentItem = this.parentElement;
        const subMenu = currentItem.querySelector('.sub-menu');
        const isOpen = currentItem.classList.contains('active');

        // Close all other submenus
        mobileNav.querySelectorAll('.menu-item-has-children').forEach((item) => {
          const otherSub = item.querySelector('.sub-menu');
          const otherLink = item.querySelector('a');

          if (item !== currentItem) {
            item.classList.remove('active');
            otherLink?.classList.remove('rotated');

            if (otherSub) {
              otherSub.classList.remove('animate-openmenu');
              otherSub.classList.add('animate-closemenu');

              setTimeout(() => {
                otherSub.classList.remove('animate-closemenu');
              }, 600); // Match with CSS transition duration
            }
          }
        });

        // Toggle current submenu
        if (isOpen) {
          currentItem.classList.remove('active');
          this.classList.remove('rotated');
          subMenu.classList.remove('animate-openmenu');
          subMenu.classList.add('animate-closemenu');

          setTimeout(() => {
            subMenu.classList.remove('animate-closemenu');
          }, 600);
        } else {
          currentItem.classList.add('active');
          this.classList.add('rotated');
          subMenu.classList.remove('animate-closemenu');

          // Force reflow to restart animation
          void subMenu.offsetWidth;

          subMenu.classList.add('animate-openmenu');
        }
      });
    });
  }

  const openMenu = () => {
    mobileMenu.classList.add('active');
    overlay.classList.add('active');
    document.body.classList.add('menu-open');
    hamburgerIcon.classList.add('hidden');
    closeIcon.classList.remove('hidden');
  };

  const closeMenu = () => {
    mobileMenu.classList.remove('active');
    overlay.classList.remove('active');
    document.body.classList.remove('menu-open');
    hamburgerIcon.classList.remove('hidden');
    closeIcon.classList.add('hidden');
  };

  menuToggle.addEventListener('click', () => {
    if (mobileMenu.classList.contains('active')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  overlay.addEventListener('click', closeMenu);
  internalCloseBtn.addEventListener('click', closeMenu);

  const updateHeader = () => {
    const currentScroll = window.scrollY;

    // Solid background toggle
    if (currentScroll > 100) {
      header.classList.add('solid');
    } else {
      header.classList.remove('solid');
    }

    // Show/hide on scroll direction
    if (currentScroll > lastScrollTop && currentScroll > 100) {
      header.classList.remove('visible-header');
      header.classList.add('hidden-header');
    } else {
      header.classList.remove('hidden-header');
      header.classList.add('visible-header');
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    ticking = false;
  };

  updateHeader();

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  });

  menuItems.forEach((item) => {
    const subMenu = item.querySelector('.sub-menu');

    item.classList.remove('open');

    item.addEventListener('mouseenter', () => {
      closeAllDropdowns();
      item.classList.add('open');
      subMenu.style.display = 'block';
    });

    item.addEventListener('mouseleave', () => {
      item.classList.remove('open');
      subMenu.style.display = 'none';
    });

    function closeAllDropdowns() {
      menuItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove('open');
          const otherSub = otherItem.querySelector('.sub-menu');
          if (otherSub) otherSub.style.display = 'none';
        }
      });
    }
  });

  document.addEventListener('click', (e) => {
    if (![...menuItems].some((item) => item.contains(e.target))) {
      menuItems.forEach((item) => {
        item.classList.remove('open');
        const subMenu = item.querySelector('.sub-menu');
        if (subMenu) subMenu.style.display = 'none';
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      const active = document.activeElement;
      if (
        active &&
        active.matches('.no-pointer-parent a[href="#"]')
      ) {
        e.preventDefault();
      }
    }
  });
});
